/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
// import Loader from 'material/loader/loader';
import CTAs from 'material/ctas/ctas';
import SaveButton from 'material/ctas/save/save';
import DiscardButton from 'material/ctas/discard/discard';
// utils
import { isContentValid } from 'utils/embeds/content_validation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedupdatecta/embedupdatecta_styles';



/* ========== ~~~~~~~~~~ CTA : EDIT INFO  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EmbedUpdateCTA extends Component {

    handleClick = e => {
        if(isContentValid(this.props.selectedContent)) {
            this.props.handleSaveEmbed()
        } else {
            this.props.invalidateSelectedContent();
            this.props.sendMessage('There are required fields you must fill out before continuing.');
        }
    };
    handleDiscard = () => {
        // this.props.discardChanges(this.props.formName);
        // this.props.setFormEditableState(this.props.formName, false)
    };
    render() {
        return (
            <div className={`embedupdatecta ${this.props.classes.embedupdatecta}`}>
                <CTAs>
                    {this.props.changeDetected ? <DiscardButton discardChanges={this.props.discardChanges} disabled={this.props.isSavingData} /> : null}
                    <SaveButton
                        handleSave={this.handleClick}
                        savingData={this.props.isSavingData}
                        buttonText={this.props.changeDetected ? null : 'Saved'}
                        disabled={!this.props.changeDetected || this.props.isSavingData}
                    />
                </CTAs>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedUpdateCTA);
